<template>
	<div class="shu-icon_view">
		<div class="shu-icon">
			<img :class="'icon'+item" v-for="item in imgList" :data-src="g+'/'+item+'.png'" />
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			type:{
				type:String,
				default:'1'
			}
		},
		name: "",
		components: {},
		data(){
			 let g=process.env.VUE_APP_BASE_URL+'sustainability'
			return{
				g:g,
				imgList:["478","479","480","481","482","483","484","485","486","487","488","489","490"],
			}
		},
		created(){}
	}
</script>

<style lang="scss" scoped >
	.shu-icon_view{
		width: 457px;
		height: 530px;
		.shu-icon{
			position: relative;
			width: 457px;
			height: 530px;
			.icon478{
				    height: 71.79px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(48.595px, 37.507px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 41.49px;
			}
			.icon479{height: 32.44px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(0.000px, 101.328px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 81.38px;}
			.icon480{height: 72.19px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(132.054px, 69.801px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 42.06px;}
			.icon481{    height: 78.17px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(199.186px, 51.752px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 35.93px}
			.icon482{    height: 49.87px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(43.121px, 353.288px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 64.37px;}
			.icon483{    height: 77.58px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(120.393px, 348.603px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 35.65px;}
			.icon484{    height: 60.85px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(247.151px, 72.135px) rotate(349.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 54.04px;}
			.icon485{height: 43.26px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(363.987px, 27.189px) rotate(359.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 36.91px;}
			.icon486{height: 67.89px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(313.856px, 0.000px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 45.77px;}
			.icon487{    height: 32.13px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(360.751px, 338.463px) rotate(353.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 52.00px;}
			.icon488{    height: 53.63px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(298.090px, 195.309px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 32.53px;}
			.icon489{height: 36.87px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(42.757px, 260.368px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 77.25px;}
			.icon490{height: 456.38px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(77.826px, 73.366px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 378.92px;}
			
		}
	}
	
</style>